import { createApp } from 'vue'

import App from './App.vue'

import 'material-design-icons-iconfont/dist/material-design-icons.css'
import "@mdi/font/css/materialdesignicons.css"
import "@fortawesome/fontawesome-free/css/all.css"
import store from "@/store"

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const fiLightTheme = {
  "dark": false,
  "colors": {
    "background": "#F5F5F5",
    "surface": "#ffffff",
    "primary": "#1C6F62",
    "secondary": "#E6E9FF",
    "chip": "#d8de31",
    "error": "#F44336",
    "info": "#2196F3",
    "success": "#4CAF50",
    "button": "#E7EA75",
    "warning": "#FFC107"
  }
};

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'fiLightTheme',
    themes: {
        fiLightTheme,
    },
  },
})

import 'vue3-flag-icons/styles'

import router from './router'

import TextClamp from 'vue3-text-clamp';
import i18n from "@/i18n";

const clickOutside = {
  beforeMount: (el, binding) => {
    el.clickOutsideEvent = event => {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        binding.value();
      }
    };
    document.addEventListener("click", el.clickOutsideEvent);
  },
  unmounted: el => {
    document.removeEventListener("click", el.clickOutsideEvent);
  },
};

createApp(App).directive("click-outside", clickOutside)
    .use(store).use(i18n).use(router)
    .use(vuetify).use(TextClamp).mount('#app')